import { useEffect } from "react";
import { useBreadcrumb } from "../AppBreadcrumb/BreadcrumbContext";

const PageHeading = ({
    additionalBreadcrumbs,
    useDefaultPath,
    data,
    orgName,
    schoolName,
    children
}) => {

    const { setBreadcrumbProps } = useBreadcrumb();

    useEffect(() => {
        setBreadcrumbProps({
            additionalBreadcrumbs,
            useDefaultPath,
            data,
            orgName,
            schoolName,
        });

        return () =>
            setBreadcrumbProps({
                additionalBreadcrumbs: [],
                useDefaultPath: true,
                data: {},
                orgName: "",
                schoolName: "",
            });
    }, [
        additionalBreadcrumbs,
        useDefaultPath,
        data,
        orgName,
        schoolName,
        setBreadcrumbProps
    ]);

    return children;
};

export default PageHeading;
